import http from "infra/http";
import { useQuery, UseQueryResult } from "react-query";
import {
  RepasseDiarioItemResponse,
  RepasseListQuery,
} from "../typings";

function buildRepasseListQueryString(params: RepasseListQuery): string {
  const search = new URLSearchParams();
  search.set("mes", String(params.mes));
  search.set("ano", String(params.ano));
  params.tenantContaIds.forEach((tenantContaId) => {
    search.append("tenantContaIds", tenantContaId);
  });
  return search.toString();
}

function useRepassesDiarios(
  params: RepasseListQuery | null
): UseQueryResult<RepasseDiarioItemResponse[], unknown> {
  return useQuery<RepasseDiarioItemResponse[]>(
    ["/v1/repasse", params],
    async () => {
      if (!params) {
        return [];
      }

      const query = buildRepasseListQueryString(params);
      const { data } = await http.get<RepasseDiarioItemResponse[]>(
        `/v1/repasse?${query}`
      );

      return data ?? [];
    },
    {
      enabled: Boolean(
        params &&
          params.tenantContaIds.length > 0 &&
          params.mes >= 1 &&
          params.mes <= 12 &&
          params.ano >= 2000 &&
          params.ano <= 2100
      ),
      keepPreviousData: true,
    }
  );
}

export default useRepassesDiarios;
